import * as z from "zod";
import { SettingsScopeSchema } from "./settings-scope.js";

export const CONTACT_FIELDS = [
  "name", "given_name", "family_name", "organization", "email", "phone",
  "address_line1", "address_line2", "city", "state", "postal_code", "country",
] as const;
export const ContactField = z.enum(CONTACT_FIELDS);
export type ContactField = z.infer<typeof ContactField>;
const line = z.string().trim().min(1).max(240).refine(value => !/[\u0000-\u001f\u007f]/.test(value), "Use a single line");
export const VaultContactName = z.string().trim().min(1).max(64).refine(value => !/[\u0000-\u001f\u007f]/.test(value), "Use a single line");
export const VaultContactValues = z.object({
  name: line.optional(), given_name: line.optional(), family_name: line.optional(),
  organization: line.optional(), email: z.email().max(254).optional(), phone: line.max(40).optional(),
  address_line1: line.optional(), address_line2: line.optional(), city: line.optional(),
  state: line.optional(), postal_code: line.max(24).optional(),
  country: z.string().trim().toUpperCase().regex(/^[A-Z]{2}$/, "Use a two-letter country code").optional(),
}).strict().refine(value => Object.values(value).some(Boolean), "Enter at least one contact field");
export type VaultContactValues = z.infer<typeof VaultContactValues>;
export const VaultContactMetadata = z.object({
  name: VaultContactName, fields: z.array(ContactField), updatedAt: z.string(),
});
export type VaultContactMetadata = z.infer<typeof VaultContactMetadata>;
export const VaultContactTarget = z.object({ scope: SettingsScopeSchema.optional(), name: VaultContactName });
export const VaultContactPut = VaultContactTarget.extend({ values: VaultContactValues });
